export default __webpack_public_path__ + "static/media/andrew_cai.2cccab44.jpg";